@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fieldLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}

// Dropdown also applies this class to its portal container, which must keep
// its own width.
.styledDropdown:not([data-dropdown-list-container]) {
  width: 100%;
}

.styledDropdown {
  // The design-system cap of 30vh makes even a 4-option list scroll on short
  // windows. Unlayered styles beat the design-system layer.
  [data-dropdown-list] {
    max-height: min(max(30vh, 200px), 320px);
  }
}

.selectWrapper {
  [data-input-element] {
    cursor: pointer;
    width: 100%;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  [data-input-wrapper] {
    @include border-radius-r2;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }
}
